import { Navigate, useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { UserContext } from 'context/userContext';
import { LoginGate } from 'components/auth/LoginGate';

/** Legacy /login route — global RequireAuth already shows LoginGate for guests. */
export const MobileLogin = () => {
  const { loggedUser } = useContext(UserContext);
  const location = useLocation();
  const redirectRoute = new URLSearchParams(location.search).get('from') ?? '/';

  useEffect(() => {
    if (loggedUser) {
      window.location.replace(redirectRoute);
    }
  }, [loggedUser, redirectRoute]);

  if (loggedUser) {
    return <Navigate to={redirectRoute} replace />;
  }

  return <LoginGate from={redirectRoute} />;
};
